import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {CommonResponse} from '../interfaces/home';

@Injectable({
  providedIn: 'root',
})
export class EndorsementTypeService {
  constructor(private http: HttpClient) { }
  baseUrl = environment.baseUrl+'EndorsementType/';
  // fetch all EndorsementType in the database
  allEndorsementTypeData(): Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl);
  }
  getEndorsementType(id: any):Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl +id);
  }
  getEndorsementTypeByName(name: any):Observable<CommonResponse>{
    return this.http.get<CommonResponse>(this.baseUrl + 'name/' + name);
  }
  postEndorsementType(data: any){
    return this.http.post(this.baseUrl, data);
  }
  deleteEndorsementType(id: any){
    return this.http.delete(this.baseUrl +id);
  }
  updateEndorsementType(id: any, data: any){
    return this.http.put(this.baseUrl +id, data);
  }
}
